"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shiftOpportunityTypePolicies = void 0;
exports.shiftOpportunityTypePolicies = {
    ShiftOpportunity: {
        keyFields: ['id', 'type']
    }
};
